import { render, staticRenderFns } from "./AppraisalTypeSelect.vue?vue&type=template&id=6d508df2&scoped=true&"
import script from "./AppraisalTypeSelect.vue?vue&type=script&lang=ts&"
export * from "./AppraisalTypeSelect.vue?vue&type=script&lang=ts&"
import style0 from "./AppraisalTypeSelect.vue?vue&type=style&index=0&id=6d508df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d508df2",
  null
  
)

export default component.exports